export const LoginConfig: any = {
  MX: {
    appid: 120022, // 自己申请的appid
    role: 2,
    lang: 'es-MX',
    city_id: 0,
    country_calling_code: '+52',
    country_id: 484,
  },
  BR: {
    appid: 200017, // 自己申请的appid
    role: 2,
    lang: 'pt-BR',
    city_id: 0,
    country_calling_code: '+55',
    country_id: 76,
  },
  CO: {
    appid: 120022, // 自己申请的appid
    role: 2,
    lang: 'es-CO',
    city_id: 0,
    country_calling_code: '+57',
    country_id: 170,
  },
  CR: {
    appid: 120022, // 自己申请的appid
    role: 2,
    lang: 'es-419',
    city_id: 0,
    country_calling_code: '+506',
    country_id: 188,
  },
  AR: {
    appid: 120022, // 自己申请的appid
    role: 2,
    lang: 'es-419',
    city_id: 0,
    country_calling_code: '+54',
    country_id: 32,
  },
}

export const billMode: any = {
  1: {
    mode: 'Fleet_NewPaymentFlow__Khbs',
    text: ['Fleet_NewPaymentFlow_CAbk_WnqE', 'Fleet_NewPaymentFlow_svTo_tbpj'],
  },
  2: {
    mode: 'Fleet_NewPaymentFlow__BVvn',
    text: ['Fleet_NewPaymentFlow_TSCH_mgfl', 'Fleet_NewPaymentFlow_svTo_tbpj'],
  },
}

export const bill = {
  sub_bill_type: {
    rent: 1001, // 租金
    other: 1014, // 其他
  },
  bill_type: {
    rent: 1, // 车辆租金
    other: 2, // 其他车头费用
  },
  bill_period: {
    0: 'Fleet_NewPaymentFlow__GUTP',
    1: 'Fleet_NewPaymentFlow__PRyq',
    2: 'Fleet_NewPaymentFlow__BevI',
    3: 'Fleet_NewPaymentFlow__QXtF',
  },
}
